export const Roles = {
    Admin: "admin",
    Accounting: "accounting",
    Operation: "operation",
    DataEntry:"data_entry",
    ReceiptEntry:"ReceiptEntry",
    Viewer: "viewer",
    Vendor:"vendor"
  };